import React from 'react';
import { PreImplantAligmentQuestion } from '../type';
import { useLang } from '../../../../util/lang';
import { useDispatch, useSelector } from 'react-redux';
import { BASE_PRESCRIPTION_NOTES_LANG_KEY } from '../RestorativeOptions/RestorativeOptions';
import { FormControlLabel, RadioGroup, Radio, Tooltip } from '@material-ui/core';
import {
    NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION,
    NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION_PROSTHETIC_SPACE,
} from '../../../../store/NewPatient/actionType';
import style from '../NewPatientPrescriptionNotes.module.css';
import { getWebAbsPath } from '../../../../util/path';
import { renderToothMarkers } from '../../NewPatientUtill';
import ErrorIcon from '@material-ui/icons/Error';

/**
 * RestorativeOptions component for displaying restorative treatment options
 * @param {Object} props - Component props
 * @param {PreImplantAligmentQuestion} props.question - The question object containing restorative options
 * @param {boolean} props.readOnly - Whether the component is in read-only mode
 * @param {Object} props.teeth - Teeth img object
 * @param {Function} props.handleToothClick - Handler for tooth click events
 */
const PreImplantAligment = ({ question, readOnly, teeth, handleToothClick }) => {
    const getNotes = useLang(`NewPatient`);
    const newPatientReducer = useSelector((store) => store.newPatientReducer);
    const { preImplantAligment } = newPatientReducer;
    const dispatch = useDispatch();
    const isRenderToothReminderIcon = () => {
        const isProstheticSpaceValid =
            preImplantAligment?.prostheticSpace &&
            Array.isArray(preImplantAligment?.prostheticSpace) &&
            preImplantAligment?.prostheticSpace.length > 0;
        return preImplantAligment?.value === 'Yes' && !isProstheticSpaceValid;
    };

    return (
        <>
            <span id="preImplantAligment">{getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.preImplantAligment`)}</span>
            <RadioGroup value={preImplantAligment?.value}>
                {question.options.map((opt, idx) => {
                    return (
                        <FormControlLabel
                            value={opt.value}
                            key={opt.value + idx.toString()}
                            control={<Radio />}
                            label={opt.label}
                            onChange={(e) => {
                                if (readOnly) return;
                                dispatch({
                                    type: NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION,
                                    value: e.target.value,
                                });
                            }}
                        />
                    );
                })}
            </RadioGroup>
            {preImplantAligment?.value === 'Yes' && (
                <>
                    <span style={{ fontWeight: 'bold', padding: 10 }}>
                        {getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.preImplantAligmentHint`)}
                    </span>
                    <div
                        className={style.toothImages}
                        style={{ display: 'flex' }}
                        id={`Q.preImplantAligmentProstheticSpace`}
                    >
                        <div
                            style={{
                                width: 1175,
                                height: 300,
                                'margin-top': '10px',
                                position: 'relative',
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/teeth_number_CS6.ai.png')}")`,
                            }}
                            onClick={(e) => {
                                if (readOnly) return;
                                console.log('e', e);
                                if (handleToothClick && typeof handleToothClick === 'function') {
                                    const dispatchFunc = (v) =>
                                        dispatch({
                                            type: NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION_PROSTHETIC_SPACE,
                                            value: v,
                                        });
                                    handleToothClick(e, dispatchFunc);
                                }
                            }}
                        >
                            {Array.isArray(preImplantAligment?.prostheticSpace) &&
                                renderToothMarkers(
                                    preImplantAligment?.prostheticSpace,
                                    teeth,
                                    '/img/prescriptionNotes/checkSuccess.png'
                                )}
                        </div>
                        {isRenderToothReminderIcon() && (
                            <div>
                                <Tooltip title={getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.attachmentTooltip`)}>
                                    <ErrorIcon style={{ color: 'red' }} />
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default PreImplantAligment;
